angular.module("exitPopupModule").component("exitPopup", {
	templateUrl: "exitPopup/exitPopup.html",
	transclude: true,
	bindings: {
		signUpUrl: "@",
		paramKw: "@",
		paramSrc: "@",
		paramTier: "@",
		listingMaskId: "@",
		buildingId: "@",
		articleId: "@",
		historyId: "@",
		termsOfUseUrl: "@",
		privacyPolicyUrl: "@",
		buildingToken: "@",
		listingToken: "@",
		searchToken: "@"
	},
	controller: ["$element", "$sce", "$scope", "$rootScope", "$window", "$cookies", "$http", "$timeout", "$document", "PubSub", "fbService", "crResourcesService", "$interval", "patterns", function(
        $element, $sce, $scope, $rootScope, $window, $cookies, $http, $timeout, $document, PubSub, fbService, crResourcesService, $interval, patterns) {
		let ctrl = this;
		// To use in registration component, as we have one tap there
		$rootScope.isExitPopupVisible = false;
		this.inProgress = false;

		this.patterns = patterns;
		this.registrationNamePattern = /^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(\s+[A-Za-zÀ-ÖØ-öø-ÿ]{2,})+$/;

		this.regularUser = {
			src: this.paramSrc,
			tier: this.paramTier,
			kw: this.paramKw,
			listingMaskId: this.listingMaskId,
			buildingId: this.buildingId,
			historyId: this.historyId,
			articleId: this.articleId,
			regPage: $window.location.href
		};
		if (this.buildingNameOrAddress) {
			this.regularUser.address = this.buildingNameOrAddress;
		}

		this.userEmailHasChanged = false;

		this.buildingAlertToken = null; // adds alert + saves to the profile
		this.listingAlertToken = null; // adds alert + saves to the profile
		this.searchAlertToken = null; // adds alert + saves to the profile

		this.steps = {
			main: "main",
			emailPassword: "emailPassword",
			success: "success"
		}

		this.popupTypes = {
			other: "other",
			building: "building",
			listing: "listing",
			search: "search"
		}

		this.popupType = this.popupTypes.other;
		if (this.buildingToken) this.popupType = this.popupTypes.building;
		if (this.listingToken) this.popupType = this.popupTypes.listing;
		if (this.searchToken) this.popupType = this.popupTypes.search;
		
		this.text = {
			title: "Before you move on from this page",
			subtitle: "Sign-up to get the latest news & updates!",
			button: "Sign up with Email",
			formTitle: "Don't miss out on the latest in NYC real estate!",
			formSubtitle: $sce.trustAsHtml("Create your CityRealty account."),
			formButton: "Sign Up"
		}

		if (this.popupType == this.popupTypes.search) {
			this.text = {
				title: "Before you move on from this page",
				subtitle: "Save this search and we'll email you when new apartments are listed!",
				button: "Save Search with Email",
				formTitle: "We are saving this search for you.",
				formSubtitle: $sce.trustAsHtml("Create your CityRealty account."),
				formButton: "Save this search"
			}
		}

		if (this.popupType == this.popupTypes.building) {
			this.text = {
				title: "Before you move on from this page",
				subtitle: "Sign-up and we'll email you new listings in this building!",
				button: "Save Building with Email",
				formTitle: "We are saving this building for you.",
				formSubtitle: $sce.trustAsHtml("Create your CityRealty account."),
				formButton: "Save this building"
			}
		}

		if (this.popupType == this.popupTypes.listing) {
			this.text = {
				title: "Before you move on from this page",
				subtitle: "Sign-up and we'll email you changes to this listing.",
				button: "Sign up with Email",
				formTitle: "We will let you know if anything changes!",
				formSubtitle: $sce.trustAsHtml("Create your CityRealty account."),
				formButton: "Keep track of this listing"
			}
		}

		this.errorMessages = {
			required: "This field is required.",
			requiredPhone: "Please enter a phone number",
			email: $sce.trustAsHtml("Are you sure?<br/>This does not look like an email."),
			emailExist: "This email already exists.",
			notFullname: "Please enter a full name.",
			phoneExist: "This phone number has been used. Please use your mobile number.",
			phoneFormat: "This phone number is not valid.",
			phoneShort: "This phone is too short (less than 6 characters).",
			minlength: "Password can't be shorter than 6 characters.",
			maxlength: "Password can't be longer than 64 characters.",
			generic: "Error, please contact us for further assistance.",
			fbError: "Login error. Contact us for further assistance."
		};

		this.activeStep = this.steps.main;

		ctrl.heartAnimation = { "nm": "Love 2", "ddd": 0, "h": 34, "w": 34, "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" }, "layers": [{ "ty": 4, "nm": "Stroke Outlines", "sr": 1, "st": 0, "op": 30, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [0, 0, 0], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }, { "ty": "tm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Trim", "nm": "Trim Paths 1", "ix": 2, "e": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 10 }, { "s": [100], "t": 26 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "s": { "a": 0, "k": 0, "ix": 1 }, "m": 1 }], "ind": 1 }, { "ty": 4, "nm": "Stroke Outlines 2", "sr": 1, "st": 0, "op": 10, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 0 }, { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 8 }, { "s": [0], "t": 10 }], "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [0, 0, 0], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 2 }, { "ty": 4, "nm": "Fill Outlines", "sr": 1, "st": 0, "op": 45, "ip": 26, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0, 0, 100], "t": 26 }, { "s": [100, 100, 100], "t": 30 }], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 3, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[0, 13.816], [0, -5.575]] }, "ix": 2 } }, { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 4 }, { "ty": "fl", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Fill", "nm": "Fill 1", "c": { "a": 0, "k": [0, 0, 0], "ix": 4 }, "r": 1, "o": { "a": 0, "k": 100, "ix": 5 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 3 }], "v": "4.12.0", "fr": 15, "op": 45, "ip": 0, "assets": [] };

		this.closePopup = () => {
			$rootScope.isExitPopupVisible = false;
		}

		this.googleButtonRender = function(suffix = 'exit') {
			if (typeof google === "undefined") {
				$timeout(function() { ctrl.googleButtonRender(suffix); }, 100);
			} else {
				let width = window.innerWidth < 1180 ? "280" : "334";
				var elem = document.getElementById("google-signin-" + suffix);
				google.accounts.id.renderButton(
					elem, {
						theme: "outline",
						size: "large",
						width: width,
						text: "continue_with",
					}
				);
			}
		};

		this.signUp = function () {
			this.regularUser.name = this.form.name.$modelValue;
			this.regularUser.email = this.form.email.$modelValue;
			this.regularUser.password = this.form.password.$modelValue;
			this.regularUser.isExitPopup = true;

			// save building
			if (ctrl.buildingToken) {
				ctrl.buildingAlertToken = ctrl.buildingToken;
			}
			if (ctrl.listingToken) {
				ctrl.listingAlertToken = ctrl.listingToken;
			}
			if (ctrl.searchToken) {
				ctrl.searchAlertToken = ctrl.searchToken;
			}

			window.crRecaptcha.execute(() => { this.signUpRecaptchaCallback(this.form); }, "registration", false);
		};

		this.signUpRecaptchaCallback = function(form) {

			var requestData = angular.extend({}, this.regularUser, { reCaptchaTokens: window.crRecaptcha.getTokens() });
			this._postRequest(requestData, form, this.signUpUrl, (data) => {
				ctrl.showSuccessStep();
			});
		};

		this.showSuccessStep = () => {
			this.activeStep = this.steps.success;
			this.initializeLottieAnimation();
			$timeout(function () {  $window.location.reload(); $rootScope.isExitPopupVisible = false; }, 3000);
		}

		this._postRequest = function (user, form, url, callback) {
			if (this.inProgress) {
				return;
			}
			this.inProgress = true;

			this.form.globalErrors = [];

			if (this.regTrigger) {
				user.regTrigger = `${this.pageId}-${this.regTrigger}`;
			}
			user.regPage = $window.location.href;

			if (typeof this.buildingAlertToken !== "undefined" && this.buildingAlertToken !== null) {
				user.buildingAlertToken = this.buildingAlertToken;
			}

			if (typeof this.listingAlertToken !== "undefined" && this.listingAlertToken !== null) {
				user.listingAlertToken = this.listingAlertToken;
			}

			if (typeof this.searchAlertToken !== "undefined" && this.searchAlertToken !== null) {
				user.searchAlertToken = this.searchAlertToken;
			}

			//this.addCallOutBoxTypeToRequest(user);

			$http({
				method: "post",
				url: url,
				data: user,
				headers: {"X-Requested-With": "XMLHttpRequest"}
			})
			.success(function(data, status, headers, config) {
				if (typeof data === "object" && data && data.data && data.data.status) {
					ctrl.inProgress = false;
					if (typeof callback === "function") {
						callback(data);
					}
				} else {
					ctrl.handleErrors(ctrl.form, data.data || {});
					ctrl.inProgress = false;
				}
			})
			.error(function(data, status, headers, config) {
				ctrl.handleGenericError(form);
				ctrl.inProgress = false;
			});
		};


		this.handleErrors = function(form, data) {
			if (form && data.form && (data.form.length || Object.keys(data.form).length)) {
				this.softErrorTracked = false;
				angular.forEach(data.form, function(error, key) {
					if (key !== "FORMSUMMARY") {
						// There is no flag to determine what type of error we got from BED
						if (key == 'first_name' || key == 'last_name') key = 'name';

						if (form[key] && error[0]) {
							// duplicated error
							if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0 ) {
								form[key].$setValidity(key + "Exist", false);
							} else if (error[0].indexOf("Your message is not clear") > 0) {
								form[key].$setValidity(key + "NotClear", false);
							} else if (error[0].indexOf("incorrect") > 0 || error[0].indexOf("valid") > 0) { // twilio phone error
								form[key].$setValidity("pattern", false);
							} else if (error[0].indexOf("a full name") > 0 || error[0].indexOf("is too short") > 0) {
								form[key].$setValidity("pattern", false);
							}
						} else {
							ctrl.handleGenericError(form, data.message);
						}
					}
				});
			} else {
				ctrl.handleGenericError(form, data.message || null);
			}
		};

		this.handleGenericError = function(form, message) {
			// we just keep one global error with a generic message
			if (form && form.globalErrors && form.globalErrors.length === 0) {
				var gError = {};
				gError.key = "error";
				gError.value = message || ctrl.errorMessages.generic;
				form.globalErrors.push(gError);
			}
		};

		this.initializeLottieAnimation = function() {
			$timeout(function() {
				let lottie_elements = $element[0].getElementsByClassName('lottie-container-exit');
				if (lottie_elements && lottie_elements.length > 0) {
					if (ctrl.animation) {
						ctrl.animation.destroy();
					}
					ctrl.animation = lottie.loadAnimation({
						container: lottie_elements[0],
						renderer: 'svg',
						loop: false,
						autoplay: true,
						animationData: ctrl.heartAnimation
					});
				}
			});
		};

		PubSub.subscribe('exitPopupRegSuccess', this.showSuccessStep);

		this.fieldChange = function(key) {
			this.userEmailHasChanged = true;

			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};

		$timeout(function() {
			ctrl.googleButtonRender();
		}, 0); // Executes after DOM is ready

		// Function to show the exit popup
		function showExitPopup() {
			// Check if the cookie is set
			var exitPopupShown = $cookies.get('exitPopupShown');
			if (!exitPopupShown) {

				var registrationElement = $document[0].querySelector('.cmp-registration-content-wrapper.opened');
                if (registrationElement) {
                    return;
                }

				// Show popup here
				$rootScope.isExitPopupVisible = true;
				// Set a cookie to expire in 1 day
				var now = new Date(),
					exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5); // set the expiration to 1 day ahead
				$cookies.put('exitPopupShown', 'true', {expires: exp});
				// You must apply the changes as this function could be called from outside AngularJS context
				if(!$scope.$$phase) $scope.$apply();
			}
		}

		let timeoutId = null;
		// Event listener for mouse leaving the window
		function handleMouseLeave(event) {
			if (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
				timeoutId = setTimeout(showExitPopup, 400);
			}
		}

		function handleMouseEnter(event) {
			// If mouse re-enters before 500ms, clear the timeout
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		}

		// Setup inactivity timer
		let inactivityTime = function() {
			let time;
			window.onload = resetTimer;
			// Events that reset the timer
			document.onmousemove = resetTimer;
			document.onkeypress = resetTimer;

			function resetTimer() {
				clearTimeout(time);
				time = setTimeout(showExitPopup, 60000); // 1 minute of inactivity
			}
		};

		// Attach the mouse leave event listener to the document
		$document.on('mouseleave', handleMouseLeave);
		$document.on('mouseenter', handleMouseEnter);

		// Initialize the inactivity timer
		inactivityTime();

		// Clean up event listener when the scope is destroyed
		$scope.$on('$destroy', function() {
			$document.off('mouseleave', handleMouseLeave);
			$document.off('mouseenter', handleMouseEnter);
		});

	}]
});
